import { render, staticRenderFns } from "./DetailOrderNonKomship.vue?vue&type=template&id=0a98dd80&"
import script from "./DetailOrderNonKomship.vue?vue&type=script&lang=js&"
export * from "./DetailOrderNonKomship.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrderNonKomship.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports